<template>
    <div class="col-xl-2 col-lg-3 col-md-4 col-6" v-show='Loading'>

     <div href="#" class="card card-sm card-product-grid " >
        <a href="#" class="img-wrap avatar"> <img > </a>
        <figcaption class="info-wrap">
            <a href="#" class="title line"></a>
            <div class="price mt-1 line"></div> <!-- price-wrap.// -->
        </figcaption>
    </div>
    
    </div>

</template>

<script>
    export default {
        props: {
            Loading: {
                type: Boolean,
                default: false
            },
        },
    }
</script>

<style lang="css" scoped>
.post {
  width: 100%;
  height: 80px;
}
.card-sm .avatar {
  width: 90%;
  height: 100px;
  background-color: #ccc;
  border-radius: 0%;
  margin: 8px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar 1.6s infinite linear;
}
.card-sm .line {
  width: 100%;
  height: 16px;
  margin-top: 12px;
  border-radius: 7px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-lines 1.6s infinite linear;
}
.card-sm .avatar + .line {
  margin-top: 11px;
  width: 100px;
}
.card-sm .line ~ .line {
  background-color: #ddd;
}
@keyframes shine-lines {
  0% {
    background-position: -100px;
  }
  40%, 100% {
    background-position: 140px;
  }
}
@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 208px;
  }
}
</style>